import { makeSelectAppLoggedIn, makeSelectAppLoggedInProcess } from "../../../app/appSelectors";
import { useDispatch, useSelector } from "react-redux";
import { MobileAppRegistrationContentStyled, MobileAppRegistrationStyled } from './styled/MobileAppRegistrationStyled';
import Registration from "../../../modules/Login/components/Registration";
import { useCallback } from 'react';
import { registrationPrepareMobileAction } from "../../mobileAppActions";
import { Loader } from "../../../components/Loader/Loader";
import { MobileRouterPaths } from '../../mobileAppConstants';
import { Redirect, useLocation } from 'react-router-dom';
import { getIsLocationPlatformDesktopSelector } from '../../../modules/Location/locationSelectors';

function MobileAppRegistration() {
    const isLoggedIn = useSelector(makeSelectAppLoggedIn());
    const dispatch = useDispatch();
    const loggedInProcess = useSelector(makeSelectAppLoggedInProcess());
    const location = useLocation();
    const isDesktop = useSelector(getIsLocationPlatformDesktopSelector);

    const registrationPrepare = useCallback((payload) => {
        dispatch(registrationPrepareMobileAction(payload))
    }, [dispatch]);

    if (isLoggedIn) {
        return <Redirect to={{
            pathname: MobileRouterPaths.default,
            search: location.search,
        }}/>
    }

    return <MobileAppRegistrationStyled>
        <Loader show={loggedInProcess}/>
        <MobileAppRegistrationContentStyled>
            <Registration registrationPrepare={registrationPrepare}/>
        </MobileAppRegistrationContentStyled>
    </MobileAppRegistrationStyled>
}

export default MobileAppRegistration;
